TECL_Notifications = {
  /**
   * Initialise any notifications on the page
   */
  Initialise: function() {
    $( ".notification-bar" )
      .find( "[name='dismiss-notification']" )
      .click( function() {
        // Remove the notification that this dismiss button belongs to
        var notification = $( this ).closest( ".notification" );
        TECL_Notifications.Dismiss( notification );
      } );

    TECL_Notifications.RemoveDismissedNotifications();

    $( window ).resize( function() {
      TECL_Notifications.AdjustTopSpacing();
    } );
  },

  /**
   * Dismiss a notification
   * @param {object} notification jQuery notification object
   */
  Dismiss: function( notification ) {
    var dismissedKeys = TECL_Notifications.GetDismissedNortifications();

    var key = notification.attr( "data-key" );
    dismissedKeys.push( key );
    notification.remove();

    TECL_Notifications.SaveDismissedNotifications( dismissedKeys );
    TECL_Notifications.AdjustTopSpacing();
  },

  /**
   * Get a list of notifications that have been dismissed
   */
  GetDismissedNortifications: function() {
    var dismissedKeys = [];
    try {
      dismissedKeys = JSON.parse( sessionStorage.getItem( "notifications" ) ) || [];
    } catch( e ) {
      disissedKeys = [];
    }
    return dismissedKeys;
  },

  /**
   * Save dismissed notifications back to session storage
   * @param {array} dismissed An array of dismissed notification keys
   */
  SaveDismissedNotifications: function( dismissed ) {
    try {
      sessionStorage.setItem( "notifications", JSON.stringify( dismissed ) );
    } catch( e ) {
      // Ignore errors
    }
  },

  /**
   * Remove any notifications that are already marked as dismissed
   */
  RemoveDismissedNotifications:function() {
    var dismissedKeys = TECL_Notifications.GetDismissedNortifications();
    
    dismissedKeys.forEach(function( key ) {
      $( ".notification[data-key='" + key + "']" ).remove();
    });

    if( $( ".notification" ).length >= dismissedKeys.length ) {
      // There are still visible notifications so show the notifications bar
      $( ".notification-bar" ).removeClass( "hidden" );
    }

    TECL_Notifications.AdjustTopSpacing();
  },

  /**
   * If the notification par is shown then we need to add its height to the "behind-fixed-header" element
   * otherwise the raintree page will appear behind the fixed header
   */
  AdjustTopSpacing:function() {
    var height = $( ".fixed-header" ).height();
    $( ".behind-fixed-header" ).height( height );
  }
}